import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import styled, { css, injectGlobal } from 'styled-components';
import { find } from 'lodash'
import { rgba } from 'polished';
import VisibilitySensor from 'react-visibility-sensor';
import { Save, ImageReferenceSlideshow, SlideshowModal, Attachment } from '../'

import { getChapters, fetchChapters } from '../../modules/Chapters/redux'
import { updateSettings } from '../../settings'

import { media, width } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding, bgIcon, bgImage } from '../../styles/global';

import ImageReferences from '../../modules/ImageReferences/ImageReferences';
import ArrowTopRight from 'svg-react-loader?name=Icon!../../assets/icons/arrow-top-right-black.svg';
import { isClient } from '../../utils';

class Chapter extends Component {

    state = {

    }
        
    componentDidMount = () => {
        if (this.props.scrollIndex == 0) {
            this.updatePageTitle()
        }
    }
    
    updatePageTitle = () => {
        const { updateSettings, data } = this.props;

        window.history.pushState({}, null, `/chapter/${this.getSectionSlug(data.parent_id)}/${data.slug}`);

        updateSettings({
            pageTitle: (    
                <React.Fragment>
                    <SectionTitle>{this.getSectionTitle(data.parent_id)} /</SectionTitle>
                    <Title>{data.title}</Title> 
                </React.Fragment>
            ),
            activeChapter: {
                section: this.getSectionSlug(data.parent_id),
                slug: data.slug
            }
        })
    }
    
    getSectionTitle = (parentID) => {
        const { chapters } = this.props;
        const parent = find(chapters.data, {id: parentID});

        if (parent) {
            return parent.title
        }
    }

    getSectionSlug = (parentID) => {
        const { chapters } = this.props;
        const parent = find(chapters.data, {id: parentID});

        if (parent) {
            return parent.slug
        }
    }

    onVisibilityChange = (visible) => {
        if (visible) {
            this.updatePageTitle()
        }
    }

    renderChapterTitle = () => {
        const {data} = this.props;

        return (
            <ChapterTitle>
                <SectionTitle>{this.getSectionTitle(data.parent_id)} /</SectionTitle>
                <Title>{data.title}</Title> 
            </ChapterTitle>
        )
    }
    
    renderContents = () => {
        const { data } = this.props;

        let sectionCount = 0;
        let sections;

        if (data.blocks && data.blocks.length) {
            sections = data.blocks.map((block, i) => {
                if (block.heading) {
                    sectionCount++;
                    return (
                        <IndexTitle key={i}>
                            {block.heading}
                        </IndexTitle>
                    )
                }
            })
        }

        return (
            <Contents>
                <ContentsHeader>{`In this document`}</ContentsHeader>

                <ContentsIndex
                    useColumns={sectionCount > 4}
                >
                    {sections}
                </ContentsIndex>

                <SaveWrapper>
                    <Save
                        type={'document'}
                        id={data.id}
                        saveLabel={width.phone() ? 'Save this document' : 'Save this document to favourites'}
                        removeLabel={'Remove this document'}
                    />
                </SaveWrapper>

            </Contents>
        )
    }



    renderImageReference = (ref) => {
        let tagsArray = ref.tags;
        let caption = ref.image.caption;

        const placeholder = (
            <ImageReference>
                <Image
                    image={ref.image.sizes.xlarge}
                    maintainRatio={ref.maintain_ratio}
                />

                <SaveWrapper>
                    <Save
                        white={true}
                        type={'image'}
                        id={ref.image.id}
                    />
                </SaveWrapper>

                <Info>
                    
                    <Caption>{caption}</Caption> 
                 
                    {ref.tags && (
                        <Tags>
                            {ref.tags.map((tag, i) => {
                                return (
                                    <Tag key={i}>
                                        {tag.name}
                                        {i !== (tagsArray.length - 1) && ','}
                                    </Tag>
                                )
                            })}
                        </Tags>
                    )}
                
                </Info>
            </ImageReference>
        )

        return (
            <SlideshowModal
                imageReference={true}
                images={[
                    {
                        image: {...ref.image},
                        caption: ref.caption,
                        tags: ref.tags 
                    }
                ]}
                tags={ref.tags}
                caption={ref.caption}
                placeholder={placeholder}
            />
        )
    }
    
    renderBlocks = () => {
        const { data } = this.props;

        if (data.blocks && data.blocks.length) {
            return data.blocks.map((block, i) => {
                return (
                    <Block
                        layout={block.acf_fc_layout}
                        firstBlock={i == 0}
                        key={i}
                    >
                        {block.acf_fc_layout == 'text' && this.renderTextBlock(block)}
                        {block.acf_fc_layout == 'illustration' && this.renderImageBlock(block)}
                        {block.acf_fc_layout == 'image_reference' && this.renderImageReferenceBlock(block)}
                        {block.acf_fc_layout == 'image_slideshow' && this.renderImageReferenceSlideshowBlock(block)}
                        {block.acf_fc_layout == 'image_thumbnails' && this.renderImageReferenceThumbnails(block)}
                        {block.acf_fc_layout == 'product_grid' && this.renderProductGrid(block)}
                        {block.acf_fc_layout == 'notes' && this.renderNotesBlock(block)}
                        {block.acf_fc_layout == 'table' && this.renderTableBlock(block)}
                    </Block>
                )
            })
        }
    }

    renderTextBlock = (block) => {
        return (
            <React.Fragment>
                <Header>{block.heading}</Header>

                <Columns
                    useColumns={block.use_second_column}
                >
          
                    <Text
                        dangerouslySetInnerHTML={{__html: block.content}}
                    />

                    {block.use_second_column && block.content2.length > 0 && (
                        <Text
                          dangerouslySetInnerHTML={{__html: block.content2}}
                        />
                    )}

                </Columns>
        
            </React.Fragment>
        )
    }

    renderImageBlock = (block) => {
        if (block.image) {
            return (
                <React.Fragment>
                    <SingleImage
                        src={block.image.sizes.xlarge}
                    />
    
                    {block.image.caption && (
                        <Caption>{block.image.caption}</Caption>
                    )}
                </React.Fragment>
            )
        }
    }

    renderImageReferenceBlock = (block) => {
        return this.renderImageReference(block)
    }

    renderImageReferenceSlideshowBlock = (block) => {
        return (
            <SlideshowModal 
                images={block.images}
                placeholder={
                    <ImageReferenceSlideshow
                        images={block.images}
                    />
                }
            />
        )
    }

    renderImageReferenceThumbnails = (block) => {
        const refs = block.images.map((ref, i) => {
            return (
                this.renderImageReference(ref)
            )
        })

        return (
            <ImageReferenceGrid>
                {refs}
            </ImageReferenceGrid>
        )
    }

    renderProducts = (products) => {
        return (
            <Products>
                <Images>
                    {products.productData.map((product, i) => {
                        return (
                            <Product
                                src={product.image.sizes.large[0]}
                            />
                        )
                    })}
                </Images>

                <Title>{products.title}</Title>
            </Products>
        )
    }

    renderProductGrid = (block) => {
        const refs = block.items.map((products, i) => {
            return (
                this.renderProducts(products)
            )
        })

        return (
            <ProductGrid>
                <Heading>{block.heading}</Heading>
                <SubHeading>{block.sub_heading}</SubHeading>

                {block.show_total_measurements && (
                    <TotalMeasurement>{`${block.totalWidth} lineal mm`}</TotalMeasurement>
                )}

                <Grid>{refs}</Grid> 
            </ProductGrid>
        )
    }
    
    renderNotesBlock = (block) => {
        return (
            <React.Fragment>
                NOTES
                <Text
                    dangerouslySetInnerHTML={{__html: block.content}}
                />
            </React.Fragment>
        )
    }

    renderTableBlock = (block) => { 

        if (block.table) {
            return (
                <React.Fragment>
                    {block.heading && (
                        <Header>{block.heading}</Header>
                    )}

                    <Table>
                        <Header>
                            {block.table.header.map((header, i) => {
                                return (
                                    <HeaderCell>
                                        {header.c}
                                    </HeaderCell>
                                )
                            })}
                        </Header>
                        <Rows>
                            {block.table.body.map((row, i) => {
                                return (
                                    <Row>
                                        {row.map((cell, i) => {
                                            return (
                                                <Cell>
                                                    {cell.c}
                                                </Cell>
                                            )
                                        })}
                                    </Row>
                                )
                            })}
                        </Rows>
                    </Table>
                </React.Fragment>
            )
        }
    }

    renderFooterHeader = () => {
        const { data } = this.props;

        return (
            <FooterHeader>
                <SaveWrapper>
                    <Save
                        large={true}
                        type={'document'}
                        id={data.id}
                        saveLabel={width.phone() ? 'Save this document' : 'Save this document to favourites'}
                        removeLabel={'Remove this document'}
                    />
                </SaveWrapper>
        
                {/* <Info>  
                    {data.title}
                </Info> */}
            </FooterHeader>
        )
    }

    renderFooterTags = () => {
        const { data } = this.props;
        
        let tagsCount = 0;

        if (data.tags && data.tags.length) {
            
            let tags = data.tags.map((tag, i) => {
                tagsCount++;
                return (
                    <Title key={i}>
                        {tag.name}
                    </Title>
                )
            })
        

            return (
                <FooterSection
                    section={'tags'}
                >
                    <Title>Tagged</Title>
    
                    <TagIndex
                        useColumns={tagsCount > 4}
                    >
                        {tags}
                    </TagIndex>
                </FooterSection>
            )
        }
    }

    renderFooterRelatedPages = () => {
        const { data } = this.props;

        if (data.relatedPages && data.relatedPages.length) {
            return (
                <FooterSection
                    section={'related-pages'}
                >
                    <Title>Related Pages</Title>
    
                    <PageIndex>
                        {data.relatedPages.map((page, i) => {
                            return (
                                <RelatedPage
                                    to={`/chapter/${page.slug}`}
                                    key={i}
                                >
                                    <SectionTitle>{page.section} /</SectionTitle>
                                    <Title>{page.title}</Title>
                                </RelatedPage>
                            )
                        })}
                    </PageIndex>
                </FooterSection>
            )
        }
    }

    renderFooterAttachedPages = () => {
        const { data } = this.props;

        if (data.attachedPages && data.relatedPages.length) {
            return (
                <FooterSection
                    section={'attached-pages'}
                >
                    <Title>Attached Pages</Title>
    
                    <PageIndex>
                        {data.attachedPages.map((page, i) => {
                            return (
                                <RelatedPage
                                    to={`/chapter/${page.slug}`}
                                    key={i}
                                >
                                    <Title>{page.title}</Title>
                                    <Arrow/>
                                </RelatedPage>
                            )
                        })}
                    </PageIndex>
                </FooterSection>
            )
        }
    }

    renderFooterDownloads = () => {
        const { data } = this.props;

        if (data.downloads && data.downloads.length) {
            return (
                <FooterSection
                    section={'downloads'}
                >
                    <Title>Downloads</Title>

                    <Downloads>
                        {data.downloads.map((attachment, i) => {
                            return (
                                <Attachment
                                    label={attachment.title}
                                    size={attachment.size}
                                    url={attachment.url}  
                                    key={i}          
                                    file={attachment}                    
                                />
                            )
                        })}
                    </Downloads>
                </FooterSection>
            )
        }
    }

    renderFooter = () => {
        const { data } = this.props;

        return (
            <Footer>
                {this.renderFooterHeader()}
                {this.renderFooterTags()}
                {this.renderFooterRelatedPages()}
                {this.renderFooterAttachedPages()}
                {this.renderFooterDownloads()}
            </Footer>
        )
    }
    
    render() {
        const { scrollIndex } = this.props;

        return (
            <VisibilitySensor
                onChange={this.onVisibilityChange} 
                partialVisibility={true}
                offset={isClient() && {
                    bottom: (window.innerHeight)
                }}
            >
                <Container
                    paddingTop={scrollIndex > 0}
                >
                    {scrollIndex > 0 && this.renderChapterTitle()}
                    {this.renderContents()}
                    {this.renderBlocks()}
                    {this.renderFooter()}
                </Container>
            </VisibilitySensor>
        )
    }
}

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 0;

    ${media.phone`
        flex-direction: column;
    `}
`

// Shared

const Caption = styled.div``

const Image = styled.div`
    ${bgImage}
    background-image: url(${props => props.image});

    ${props => {

        if (props.maintainRatio) return css`
            background-size: contain;
            background-position: left center;
        `
    }}
`

const Header = styled.div``
const Info = styled.div``
const SaveWrapper = styled.div``
const Title = styled.div``

// Tags

const Tags = styled.div`
    display: flex;
`

const Tag = styled.div`
    &:not(:last-child) {
        margin-right: 4px;
    }
`

// Chapter Title

const ChapterTitle = styled.div`
    display: flex;
    background: #EBEADE;
    font-size: 24px;
    ${padding}
    transform: translateY(1px);
    align-items: center;
    height: 65px;
    border-bottom: 1px solid black;
    border-top: 1px solid black;

    ${media.phone`
        font-size: 22px;
    `}
`

// Contents

const Contents = styled.div`
    padding: 18px 20px 17px;
    position: relative;

    font-size: 16px;
    color: #000000;
    border-bottom: 1px solid black;

    ${SaveWrapper} {
        position: absolute;
        right: 19px;
        top: 20px;
    }

    ${media.phone`
        padding-bottom: 50px;
        ${padding}
        padding-top: 12px;

        ${SaveWrapper} {
            bottom: 0;
            left: 0;
            right: 0;
            top: auto;
            border-top: 1px solid black;
            height: 36px;
            padding-bottom: 2px;
            ${padding}

            display: flex;
            align-items: center;
        }
    `}
`

const ContentsHeader = styled.div`
    font-weight: bold;
`

const ContentsIndex = styled.div`
    ${props => {
        if (props.useColumns) return css`
            columns: 2;
            column-gap: 40px;
            max-width: 800px;
            margin-top: 5px;
        `
    }}
`

const IndexTitle = styled.div`
    line-height: 1.1em;
    margin: 5px 0;
    &:first-child{
        margin-top: 0;
    }
`

// Blocks

const Block = styled.div`
    padding: 0 19px;
    margin-top: ${props => props.firstBlock ? 32 : 0}px;
    box-sizing: border-box;
    width: 100%;

    ${media.phone`
        ${padding}
        margin-top: ${props => props.firstBlock ? 16 : 0}px;
    `}

    ${props => {
        if (props.layout == 'text') return blockText
        if (props.layout == 'illustration') return blockImage
        if (props.layout == 'image_reference') return blockImageReference
        if (props.layout == 'image_slideshow') return blockImageReferenceSlideshow
        if (props.layout == 'image_thumbnails') return blockImageReferenceThumbnails
        if (props.layout == 'product_grid') return blockProductGrid
        if (props.layout == 'notes') return blockNotes
        if (props.layout == 'table') return blockTable
    }}   
`

// Block Text

const blockText = css`
    padding-right: 38px;
    margin-bottom: 48px;

    ${Header} {
        font-size: 16px;
        text-transform: uppercase;
        margin-bottom: 16px;
        font-weight: bold;
    }

    ${media.phone`
        margin-bottom: 30px;
    `}
`

const Columns = styled.div`
    display: flex;

    ${props => {
        if (props.useColumns) return css`

            ${Text} {
                flex: 1;
            }

            > *:first-child {
                padding-right: 20px;
            }

            ${media.tablet`
                display: block;

                > *:first-child {
                    padding-right: 0;
                }
            `}
        `
    }}
`

const Text = styled.div`
    font-size: 16px;
    line-height: 19px;
    color: #000000;
    max-width: calc(50% - (17px / 2));

    strong {
        font-weight: bold;
    }

    p {
        margin-bottom: 19px;

        &:last-child {
            margin-bottom: 0;
        }
    } 

    ul {
        margin-top: 0;
        padding-left: 20px;
    }

    ${media.tablet`
        max-width: none;
    `}

    ${media.phone`
        font-size: 16px;

        ul {
            padding-left: 24px;
        }
    `}
`

// Block Image 

const blockImage = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 0 auto;
    margin-bottom: 72px;

    ${Caption} {
        margin-top: 40px;
        font-size: 24px;
        text-align: center;
        text-transform: uppercase;
    }

    ${media.phone`
        margin-bottom: 49px;

        ${Caption} {
            font-size: 22px;
        }
    `}

`

const SingleImage = styled.img`
    max-width: 611px;
    height: auto;

    ${media.phone`
        width: 100%;
    `}
`

// Block Image Reference 

const blockImageReference = css`
    margin-bottom: 64px;

    ${media.phone`
        margin-bottom: 27px;
    `}
`



const ImageReference = styled.div`
    max-width: 693px;
    position: relative;

    ${Image} {
        width: 100%;
        height: 467px;
        
    }

    ${Info} {
        margin-top: 8px;
        display: flex;
        justify-content: space-between
    }

    ${SaveWrapper} {
        position: absolute;
        top: 20px;
        left: 17px;
        opacity: 0;
        transition: opacity 0.25s ease;
    }

    ${media.phone`
        ${Image} {
            height: 200px;
        }

        ${Info} {
            flex-direction: column;
        }

        ${SaveWrapper} {
            opacity: 1;
        }
    `}

    &:hover {
        ${SaveWrapper} {
            opacity: 1;
        }
    }
`

// Block Image Reference Slideshow

const blockImageReferenceSlideshow = css`
    margin-bottom: 38px;
    padding: 0;

    ${media.phone`
        padding: 0;
    `}
`

// Block Image Reference Thumbnails

const blockImageReferenceThumbnails = css`
    margin-bottom: 38px;
    ${padding}
`

const ImageReferenceGrid = styled.div`
    display: flex;
    flex-flow: row wrap;
    width: calc(100% + 17px);
    padding: 13px 0;
    box-sizing: border-box;

    ${media.phone`
        width: 100%;
    `}

    > * {
        display: flex;
        flex-direction: column;
        flex: 0 1;
        flex-basis: calc(33.3% - 17px);
        margin-right: 17px;
        margin-bottom: 30px;

        ${media.phone`
            flex-basis: calc(50% - 17px);
        `}

        ${media.phone`
            flex-basis: calc(100% - 17px);
        `}

        ${Image} {
            /* height: 224px; */
            height: 16.66vw;
        }

        ${SaveWrapper} {
            top: 10px;
            left: 10px;
        }

        ${Info} {
            flex-direction: column;

            ${Tags} {
                margin-top: 4px;
            }
        }
    }
`

// Block Product Grid

const blockProductGrid = css`
    margin-bottom: 38px;

    ${media.phone`

    `}
`


const Heading = styled.div`
    position: relative;
    font-weight: bold;

    &::after {
        position: absolute;
        content: '';
        left: 0;
        right: 0;
        bottom: 0;
        border-bottom: 2px solid black;
        padding-bottom: 2px;
    }
`
const SubHeading = styled.div`
    font-weight: bold;
    margin-top: 16px;
`

const TotalMeasurement = styled.div``

const Grid = styled.div`
    display: flex;
    flex-flow: row wrap;
    width: calc(100% + 17px);
    padding: 13px 0;
    box-sizing: border-box;
    margin-top: 32px;

    ${media.phone`
        width: 100%;
    `}

    > * {
        display: flex;
        flex-direction: column;
        flex: 0 1;
        margin-right: 17px;
        margin-bottom: 48px;

        ${media.phone`
            flex-basis: calc(50% - 17px);
        `}

        ${media.phone`
            flex-basis: calc(100% - 17px);
        `}
    }
`

const ProductGrid = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`

const Products = styled.div`
    ${Title} {
        margin-top: 16px;
    }
`

const Images = styled.div`
    display: flex;
    align-items: flex-end;
    padding-right: 48px;
`

const Product = styled.img`
    width: auto;
    height: 100%;
    max-height: 90px;

    ${media.phone`
        max-height: 80px;
    `}
`

// Block Notes

const blockNotes = css`
    margin-bottom: 64px;
    font-size: 14px;

    ${Text} {
        font-size: 14px;
        max-width: none;

        p:not(last-child) {
            margin-bottom: 19px;
        } 
    }
`

// Block table

const blockTable = css`
    margin-bottom: 54px;
    overflow-x: scroll;

    > ${Header} {
        text-transform: uppercase;
        margin-bottom: 7px;
    }
`

const cell = css`
    flex: 0 1 250px;
    border-top: 1px solid black;
    padding: 7px 0;

    &:not(:last-child) {
        padding-right: 10px;
    }    
`

const row = css`

`

const Table = styled.div`
    min-width: 600px;
    
    ${Header} {
        display: flex;
        ${row}
        text-transform: uppercase;
    }
`

const HeaderCell = styled.div`
    ${cell}
    
`

const Rows = styled.div`
    display: flex;
    flex-direction: column;
`

const Row = styled.div`
    display: flex;
    /* flex: 1; */
    ${row}
`

const Cell = styled.div`
    ${cell}
`

// Footer


const Footer = styled.div`
    margin-bottom: 180px;
`

const footerPanel = css`
    
    display: flex;
    flex: 1 0 auto;
    padding: 12px 15px 24px 20px;
    border-bottom: 1px solid black;

    ${media.phone`
        flex-direction: column;
        align-items: stretch;
        ${padding}
        padding-bottom: 13px;
    `}
`

const FooterSection = styled.div`
    ${footerPanel}

    > ${Title} {
        font-size: 24px;
        flex: 0 1 250px;
    }

    ${props => {
        if (props.layout == 'tags') return footerTags
        if (props.layout == 'related-pages') return footerRelatedPages
        if (props.layout == 'downloads') return footerDownloads
    }} 

    ${media.phone`
        flex-direction: column;

        > ${Title} {
            flex: 0 1 auto;
            margin-bottom: 4px;
            font-size: 22px !important;
        }
    `}
`

// Footer Header

const FooterHeader = styled.div`
    ${footerPanel}
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid black;
    padding-bottom: 12px;

    ${Info} {
        display: flex;
        font-size: 24px;
        text-transform: uppercase;
    }

    ${media.phone`
        padding: 0;
        position: relative;

        ${SaveWrapper} {
            border-bottom: 1px solid black;
            height: 36px;
            padding-bottom: 2px;
            ${padding}

            display: flex;
            align-items: center;
        }

        ${Info} {
            ${padding}
            font-size: 22px;
            padding-top: 7px;
            padding-bottom: 7px;
        }
    `}
`

const Date = styled.div`
    color: #9C9B8F;
    margin-left: 11px;
`

// Footer Tags

const footerTags = css`

`

const TagIndex = ContentsIndex.extend`
    ${Title} {
        font-size: 16px;
    }

    ${media.phone`
        columns: auto;
    `}
`

// Footer Related & Attached Pages

const footerRelatedPages = css`

`

const PageIndex = styled.div`

`

const SectionTitle = styled.div`
    color: #9C9B8F;
    margin-right: 8px;
`

const Arrow = styled(ArrowTopRight)`
    margin-left: 8px;
    transform: translateY(2px);
    background: #EBEADE;
`


const RelatedPage = styled(Link)`
    display: flex;
    font-size: 24px;
    align-items: center;
    ${hoverState}

    ${media.phone`
        ${Title} {
            font-size: 16px;
        }

        ${Arrow} {
            height: 10px;
            width: 10px;
            margin-left: 5px;
            transform: translateY(0);
        }
    `}
`


// Footer Downloads

const footerDownloads = css`

`

const Downloads = styled.div`
    display: flex;
    flex-flow: row wrap;
    width: calc(100% + 17px);
    padding: 13px;
    padding-top: 8px;
    box-sizing: border-box;
    flex: 1;

    > * {
        display: flex;
        flex-direction: column;
        flex: 0 1;
        flex-basis: calc(33.3% - 17px);
        margin-right: 17px;
        margin-bottom: 30px;
    }

    ${media.phone`
        padding-left: 0;
        padding-bottom: 0;
        flex-direction: column;

        > * {
            flex: 0;
            margin-bottom: 8px;
            margin-right: 0;
        }
    `}
`

const mapDispatchToProps = dispatch => ({
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    chapters: getChapters(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(Chapter);



// WEBPACK FOOTER //
// ./client/components/Chapter/Chapter.js